export const cookieContent = {
  'es': {
    'consent_modal': {
      title: 'Usamos cookies propias y de terceros',
      description: 'Utilizamos cookies propias y de terceros con la finalidad de personalizar el contenido de la web y los anuncios que puedan aparecer para adaptarlo a tus preferencias, así como ofrecer funciones sociales y analizar el tráfico de la web. Además, compartimos información sobre el uso que haga del sitio web con nuestros colaboradores de redes sociales, publicidad y análisis web, quienes pueden combinarla con otra información que les haya proporcionado o que hayan recopilado a partir del uso que haya hecho de sus servicios. Igualmente, puedes modificar tus opciones de consentimiento en cualquier momento y visitar nuestra Política de Cookies para obtener más información haciendo clic <button type="button" data-cc="c-settings" class="cc-link">aquí</button>.',
      primary_btn: {
        text: 'Aceptar todo',
        role: 'accept_all'              // 'accept_selected' or 'accept_all'
      },
      secondary_btn: {
        text: 'Rechazar todo',
        role: 'accept_necessary'        // 'settings' or 'accept_necessary'
      }
    },
    settings_modal: {
      title: 'Preferencias de cookies',
      save_settings_btn: 'Guardar configuración',
      accept_all_btn: 'Aceptar todo',
      reject_all_btn: 'Rechazar todo',
      close_btn_label: 'Cerrar',
      cookie_table_headers: [
        {col1: 'Nombre'},
        {col2: 'Dominio'},
        {col3: 'Expiración'},
        {col4: 'Descripción'}
      ],
      blocks: [
        {
          title: 'Uso de cookies 📢',
          description: 'Usamos cookies para asegurar el funcionamiento básico del sitio y para mejorar la experiencia de nuestros usuarios, por ejemplo para guardar tus preferencias. A continuación, puedes elegir de cada categoría aquellas que quieras aceptar/rechazar. Para más información relativa a las cookies y otros datos sensibles, lee nuestra <a href="/politica-de-privacidad" target="_blank" class="cc-link">política de privacidad</a>.'
        }, {
          title: 'Cookies estrictamente necesarias',
          description: 'Estas cookies son esenciales para el correcto funcionamiento del sitio. Sin estas cookies, el sitio no podrías funcionar adecuadamente.',
          toggle: {
            value: 'necessary',
            enabled: true,
            readonly: true          // cookie categories with readonly=true are all treated as "necessary cookies"
          }
        }, {
          title: 'Más información',
          description: 'Para cualquier pregunta en relación a nuestra política de cookies y sus opciones, por favor <a class="cc-link" href="/contacto">ponte en contacto</a> con nosotros.',
        }
      ]
    }
  }
}
